import React from 'react';

import * as customStyled from '../styles';
import { AccordionItemProps } from '../types';

const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  id,
  descriptionItems,
  collapsibleContent,
  collapsibleCallback,
  showLessIcon,
  showMoreIcon
}) => {
  const renderDescriptionItems = () => {
    return descriptionItems.map((description: string[], index: number) => {
      if (description.length === 1) {
        return (
          <li key={index} css={customStyled.collapisibleContentItem}>
            {description}
          </li>
        );
      } else {
        return (
          <ul key={index}>
            {description.map((item, index1) => {
              return (
                <li key={index1} css={customStyled.collapisibleContentItem}>
                  <span css={customStyled.spanStyle} />
                  {item}
                </li>
              );
            })}
          </ul>
        );
      }
    });
  };

  return (
    <div>
      <div css={customStyled.boxStyle}>
        <div
          css={customStyled.accordionItemWrapper}
          onClick={() => collapsibleCallback(id)}
          data-testid="accordion-item-container">
          <h3 css={customStyled.collapisibleTitle}>{title}</h3>
          <div
            css={
              collapsibleContent === id
                ? customStyled.showLessStyle(showLessIcon)
                : customStyled.showMoreStyle(showMoreIcon)
            }
          />
        </div>
        <div
          css={customStyled.collapisibleContentWrapper(
            collapsibleContent === id
          )}>
          <ul>{renderDescriptionItems()}</ul>
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
